import React from 'react';
import { volumes } from '../data/teater';

// Neutral placeholders drawn with CSS while the TEATERKLAR images in data/teater.ts are empty.
export function ProductBoxPlaceholder({
  className = ''
}: {
  className?: string;
}) {
  return <div role="img" aria-label="TEATERKLAR™ – 6 digitala volymer för drama och teater" className={`relative mx-auto w-full max-w-sm ${className}`} data-id="element-270" data-mp="bt79s6oumasa">
      <div className="rounded-2xl bg-[#1B2A5E] p-5 text-white shadow-2xl shadow-slate-900/30" data-id="element-271" data-mp="14gjro3k2duf9">
        <p className="text-xs font-semibold uppercase tracking-widest text-white/70" data-id="element-272" data-mp="19fmm6u2f4i8z">Grundskolan och gymnasiet</p>
        <p className="mt-1 font-serif text-4xl leading-none tracking-tight" data-id="element-273" data-mp="uivmsksqv6jd">TEATERKLAR<span className="align-super text-[0.45em]" data-id="element-274" data-mp="ukqbma74zisq">™</span></p>
        <p className="mt-2 text-sm leading-snug text-white/80" data-id="element-275" data-mp="zfvuf058shcl">Lektioner · Övningar · Improvisation · Föreställning · Bedömning</p>
        <div className="mt-5 grid grid-cols-6 gap-1.5" data-id="element-276" data-mp="3faxqzw1jc4z5">
          {volumes.map(v => <div key={v.number} className={`flex h-36 flex-col justify-between rounded-md border-r-4 border-black/10 p-1.5 ${v.spine}`} data-id="element-277" data-mp="3k8z9aer5009k">
              <span className="text-[9px] font-bold opacity-80" data-id="element-278" data-mp="2mu1z8rsxh43q">{v.number.replace('Volym ', 'V')}</span>
              <span className="origin-bottom-left -rotate-90 translate-x-3 whitespace-nowrap text-[10px] font-semibold" data-id="element-279" data-mp="30tbi5z8iqcbe">{v.level}</span>
            </div>)}
        </div>
        <p className="mt-4 text-center text-sm font-semibold text-[#F2B134]" data-id="element-280" data-mp="2vwl0j7h2f8nv">6 volymer + 5 bonusar</p>
      </div>
    </div>;
}
export function PagePlaceholder({
  label,
  title
}: {
  label: string;
  title: string;
}) {
  return <div className="flex h-full w-full flex-col bg-white" aria-hidden="true" data-id="element-281" data-mp="3jk1j3iej3p1m">
      <div className="flex items-center justify-between bg-[#1B2A5E] px-4 py-3 text-white" data-id="element-282" data-mp="3jm5kntoygbyq">
        <span className="text-[11px] font-bold uppercase tracking-widest" data-id="element-283" data-mp="3fj97iii6p826">TEATERKLAR™</span>
        <span className="flex h-6 w-6 items-center justify-center rounded-full bg-[#FF8A7A] text-[10px] font-bold text-[#1B2A5E]" data-id="element-284" data-mp="3tiqtyr80c98d">1</span>
      </div>
      <div className="flex flex-1 flex-col gap-3 p-5" data-id="element-285" data-mp="2m5zpf4ubw5mh">
        <p className="text-[11px] font-bold uppercase tracking-widest text-[#C8323C]" data-id="element-286" data-mp="2m7kliywajwmg">{label}</p>
        <p className="font-serif text-xl leading-tight text-slate-900" data-id="element-287" data-mp="2q7l1wp2yahw5">{title}</p>
        {[0, 1, 2, 3, 4, 5, 6].map(i => <div key={i} className="h-2.5 rounded-full bg-slate-900/10" style={{
        width: `${92 - i * 7}%`
      }} data-id="element-288" data-mp="2v4biremkxhim" />)}
        <div className="mt-auto grid grid-cols-3 gap-2" data-id="element-289" data-mp="2zyz9lk522o0d">
          <div className="h-14 rounded-md bg-[#7B4FA0]/20" data-id="element-290" data-mp="34vfv06kveo9r" />
          <div className="h-14 rounded-md bg-[#F2B134]/30" data-id="element-291" data-mp="39v2akmo68glq" />
          <div className="h-14 rounded-md bg-[#FF8A7A]/25" data-id="element-292" data-mp="39xez5iofpp7r" />
        </div>
      </div>
    </div>;
}